module.exports = __webpack_public_path__ + "static/media/bermudas.ab37fbf7.jpg";